import React, { useEffect } from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { FuseAnimate } from '@fuse';
import clsx from 'clsx';
import RegisterForm from './RegisterForm';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import BrandingPanel from '../login/BrandingPanel';

const useStyles = makeStyles(theme => ({
	root: {
		backgroundImage: 'url("assets/images/backgrounds/dark-material-bg.jpg")',
		color: theme.palette.primary.contrastText
	}
}));

const Register = props => {
	const classes = useStyles();

	const register = useSelector(({ fuse }) => fuse.config.register);

	useEffect(() => {
		if (!register) props.history.push('/login');
	}, [register, props.history]);

	return (
		<div className={clsx(classes.root, 'flex flex-col flex-1 flex-shrink-0 p-24 md:flex-row md:p-0 overflow-x-hidden')}>
			<BrandingPanel />

			<FuseAnimate animation={{ translateX: [0, '100%'] }}>
				<Card className="w-full max-w-400 mx-auto m-16 md:m-0" square>
					<CardContent className="flex flex-col items-center justify-center p-32 md:p-48 md:pt-64 ">
						<Typography variant="h6" className="md:w-auto mb-32 ">
							Create an account
						</Typography>

						<RegisterForm {...props} />
					</CardContent>
				</Card>
			</FuseAnimate>
		</div>
	);
};

export default Register;
